module.exports = __webpack_public_path__ + "img/xiaohongshu.ac1671b4.png";